import { Button, Table, TableBody, TableHead, TableRow } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  TableBodySkeleton,
} from '../../../common/components';
import {
  formatStockQuantity,
  getAvailableStock,
  getWarehouseLabel,
} from '../utils/inventoryArticlesUtils';

const ArticleStockByWarehouseTable = ({
  stocks = [],
  warehousesByUuid = {},
  isLoading = false,
  canModifyStock = false,
  onAdjustStock,
}) => {
  return (
    <GeneralTableBox>
      <Table size="small">
        <TableHead>
          <TableRow>
            <HeadTableCell>Depósito</HeadTableCell>
            <HeadTableCell>Stock físico</HeadTableCell>
            <HeadTableCell>Stock reservado</HeadTableCell>
            <HeadTableCell>Stock disponible</HeadTableCell>
            {canModifyStock && <HeadTableCell>Acciones</HeadTableCell>}
          </TableRow>
        </TableHead>

        <TableBody>
          {isLoading ? (
            <TableBodySkeleton colSpan={canModifyStock ? 5 : 4} />
          ) : stocks.length === 0 ? (
            <NoDataSkeleton
              colSpan={canModifyStock ? 5 : 4}
              message="No hay stock registrado para este artículo"
            />
          ) : (
            stocks.map((stock) => (
              <TableRow key={stock.uuid}>
                <RowTableCell>
                  {getWarehouseLabel(warehousesByUuid, stock.uuid_warehouse)}
                </RowTableCell>
                <RowTableCell>{formatStockQuantity(stock.quantity_on_hand)}</RowTableCell>
                <RowTableCell>{formatStockQuantity(stock.quantity_reserved)}</RowTableCell>
                <RowTableCell>{formatStockQuantity(getAvailableStock(stock))}</RowTableCell>
                {canModifyStock && (
                  <RowTableCell>
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<TuneIcon />}
                      onClick={() => onAdjustStock?.(stock)}
                    >
                      Ajustar stock
                    </Button>
                  </RowTableCell>
                )}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default ArticleStockByWarehouseTable;
